module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/fancy-box/fancy-box-with-text/fancy-box-with-text.component.scss
// module id = ./src/app/features/fancy-box/fancy-box-with-text/fancy-box-with-text.component.scss
// module chunks = main